import React from "react";
import {
  IonModal,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonButton,
  IonContent,
  IonItem,
  IonLabel,
  IonText,
  IonToolbar as IonToolbarInner,
  IonAccordionGroup,
  IonAccordion,
  IonList,
  IonAvatar,
  IonLoading,
} from "@ionic/react";
import { Crew } from "../../context/CrewContext";

type ResolvedCrewMember = {
  uid: string;
  first: string;
  last: string;
  company: string;
  avatar: string;
  found: boolean;
};

type Props = {
  isOpen: boolean;
  onDidDismiss: () => void;

  selectedCrew: Crew | null;

  onEditCrewDetails: () => void;
  onOpenEditMembers: () => void;
  onDeleteCrew: () => void;

  deletingCrew: boolean;
  savingMembers: boolean;
  savingCrew: boolean;

  crewMembersResolved: ResolvedCrewMember[];

  getInitials: (name: string) => string;
};

export const CrewDetailsModal: React.FC<Props> = ({
  isOpen,
  onDidDismiss,
  selectedCrew,
  onEditCrewDetails,
  onOpenEditMembers,
  onDeleteCrew,
  deletingCrew,
  savingMembers,
  savingCrew,
  crewMembersResolved,
  getInitials,
}) => {
  return (
    <IonModal
      isOpen={isOpen}
      onDidDismiss={onDidDismiss}
    >
      <IonHeader>
        <IonToolbar
          color="secondWarning"
        >
          <IonTitle>
            {selectedCrew?.name || "Crew"}
          </IonTitle>

          <IonButtons
            slot="start"
          >
            <IonButton
              disabled={deletingCrew}
              onClick={onDidDismiss}
            >
              Close
            </IonButton>
          </IonButtons>

          <IonButtons
            slot="end"
          >
            <IonButton
              onClick={onEditCrewDetails}
            >
              Edit
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>

      <IonContent>
        <div style={{ marginTop: "14px" }}>
          <IonItem
            lines="none"
          >
            <IonLabel
              className="ion-text-wrap"
            >
              <strong>Description</strong>

              <div style={{ marginTop: "6px" }}>
                <IonText
                  color="medium"
                >
                  {selectedCrew?.description && selectedCrew.description.trim().length > 0
                    ? selectedCrew.description
                    : "No description"}
                </IonText>
              </div>
            </IonLabel>
          </IonItem>

          <div style={{ marginTop: "14px" }}>
            <IonToolbarInner
            >
              <IonButtons
                slot="start"
              >
                <IonButton
                  slot="start"
                  color="danger"
                  fill="outline"
                  onClick={onDeleteCrew}
                  disabled={savingMembers || savingCrew || deletingCrew}
                >
                  Delete Crew
                </IonButton>
              </IonButtons>

              <IonButtons
                slot="end"
              >
                <IonButton
                  fill="solid"
                  color="secondWarning"
                  onClick={onOpenEditMembers}
                >
                  Members +/-
                </IonButton>
              </IonButtons>
            </IonToolbarInner>

            {crewMembersResolved.length === 0 ? (
              <IonItem
                lines="none"
              >
                <IonLabel
                  color="medium"
                >
                  No members yet.
                </IonLabel>
              </IonItem>
            ) : (
              <IonAccordionGroup
                value="crew-members" // keeps it open by default
              >
                <IonAccordion
                  value="crew-members"
                >
                  <IonItem
                    slot="header"
                    lines="full"
                  >
                    <IonLabel
                    >
                      <strong>
                        {crewMembersResolved.length} {""} Members
                      </strong>
                    </IonLabel>
                  </IonItem>

                  <div slot="content">
                    <IonList
                    >
                      {crewMembersResolved.map((m) => {
                        const name = `${m.first} ${m.last}`.trim() || "Associate";

                        return (
                          <IonItem
                            key={m.uid}
                            lines="full"
                          >
                            <IonAvatar
                              slot="start"
                            >
                              {m.avatar ? (
                                <img
                                  src={m.avatar}
                                  alt={name}
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                  }}
                                />
                              ) : (
                                <div
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontWeight: 800,
                                    fontSize: "14px",
                                    background: "#e5e5e5",
                                    color: "#333",
                                  }}
                                >
                                  {getInitials(name)}
                                </div>
                              )}
                            </IonAvatar>

                            <IonLabel
                              className="ion-text-wrap"
                            >
                              <strong>{name}</strong>

                              {m.company ? (
                                <div style={{ marginTop: "2px" }}>
                                  <IonText
                                    color="medium"
                                  >
                                    {m.company}
                                  </IonText>
                                </div>
                              ) : !m.found ? (
                                <div style={{ marginTop: "2px" }}>
                                  <IonText
                                    color="medium"
                                  >
                                    Not in your associates list
                                  </IonText>
                                </div>
                              ) : null}
                            </IonLabel>
                          </IonItem>
                        );
                      })}
                    </IonList>
                  </div>
                </IonAccordion>
              </IonAccordionGroup>
            )}
          </div>

          <div style={{ padding: "14px" }}></div>

          <IonLoading isOpen={deletingCrew} message="Deleting..." />
        </div>
      </IonContent>
    </IonModal>
  );
};
